"use client"

import Image from "next/image"

const partners = [
  {
    src: "/tsp/logo-us-ski-team.svg",
    alt: "US Ski Team",
    className: "h-32 w-40 px-2 object-contain",
  },
  {
    src: "/tsp/logo-saq.svg",
    alt: "Ski Acrobatique Québec",
    className: "h-18 w-40 px-2 object-contain",
  },
  {
    src: "/tsp/logo-alpe-dhuez.png",
    alt: "Alpe d'Huez",
    className: "h-20 w-32 px-2 object-contain",
  },
]

export default function Testimonials() {
  return (
    <>
      <div className="flex w-full flex-col justify-center md:items-center md:justify-between md:text-center">
        <h2 className="mb-4 text-3xl font-bold md:text-4xl">
          They <span className="text-primary font-extrabold">trust</span> us,
          why not you?
        </h2>
      </div>
      <div className="flex w-full flex-col items-center justify-center px-4 md:px-0">
        <div className="mx-auto w-full">
          <div
            className="group relative mt-6 flex gap-6 overflow-hidden p-2"
            style={{
              maskImage:
                "linear-gradient(to left, transparent 0%, black 20%, black 80%, transparent 95%)",
            }}
          >
            {Array(5)
              .fill(null)
              .map((_, index) => (
                <div
                  key={index}
                  className="animate-logo-cloud flex shrink-0 flex-row items-center justify-around gap-6"
                >
                  {partners.map((p, i) => (
                    <Image
                      key={`${index}-${i}`}
                      src={p.src}
                      alt={p.alt}
                      width={500}
                      height={500}
                      className={p.className}
                    />
                  ))}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  )
}
